import { Injectable } from '@angular/core';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class MngService {

  public pcRoutes: { module: string; modulePath: string; path: string; }[];

  constructor(private commonService: CommonService) {}

  async getRoutes() {
    if (this.pcRoutes !== undefined) return;

    this.pcRoutes = [];
    await import('../app-routing.module').then((m) => {
      this.addPath("", m);
    });
    await import('../module/task-routing.module').then((m) => {
      this.addPath("task", m);
    });

    this.pcRoutes.sort((a, b) => {
      if (a.path < b.path) return -1;
      if (a.path > b.path) return 1;
      return 0;
    });
  }

  addPath(module: string, m: any) {
    let rootPath = "";
    if (module !== "") rootPath = module + "/";
    let list = m.routes.filter((item) => item.loadChildren == undefined).forEach((item) => {
      this.pcRoutes.push({module: module, modulePath: item.path, path: rootPath + item.path});
    });
  }
}
